<template>
  <div></div>
</template>

<script lang="ts">
import { UAParser } from 'ua-parser-js'
import { Component, Vue } from 'vue-property-decorator'
import Config from '@/config/vue.config'

@Component
export default class FeedCamera extends Vue {
  created() {
    this.replaceUrlIfIOS()

    // 1秒後にreality.appにリダイレクト
    setTimeout(function () {
      window.location.href = '/'
    }, 1000)
  }

  // X(iOS)で開くとアプリが起動しないようなので、CustomUrlSchemeに置き換える
  replaceUrlIfIOS() {
    const ua = window.navigator.userAgent
    const isIos = new UAParser(ua).getOS().name === 'iOS'

    if (isIos) {
      let path = window.location.pathname
      if (path.startsWith('/')) {
        // pathの先頭の `/` は不要なので削る
        path = path.substring(1)
      }

      // クエリパラメータも含めてDeepLinkを構築
      const queryString = window.location.search
      const fullPath = path + queryString

      window.location.href = `${Config.customUrlScheme}${fullPath}`
    }
  }
}
</script>
